import AssignmentIcon from "@mui/icons-material/Assignment";
import ListClasses from "./List";
import { CLASSES, StudentServicePath } from "utils/constants";
import permissions from "app/permissions";

export const resources = {
  isMenu: true,
  icon: <AssignmentIcon />,
  name: StudentServicePath + CLASSES,
  title: "Занятия",
  list: <ListClasses />,
  permission: permissions.canPreviewProfessorsClasses,
};
